// extracted by mini-css-extract-plugin
export default {"grid_row":"Table_grid_row__-37+G","cell":"Table_cell__SLziz","grid_row_double":"Table_grid_row_double__-JqcO"};